module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAAAsSAAALEgHS3X78AAABQklEQVRIx+2WzU3DQBCFPyPEhQPuAHcQd4ArQHSAS0gpoQGUEhASnF2CS9gThwghp4KXQ9YQot3J2jiRQKy0l3m782ZG85dJ4pTnjBOfv094nvIog4LtBXACN5pRUvQiFUhNAFwi5dZfQ2cUKJE643c3htQCmgQNjX9be68bpLlliOVdqtmPAVkbI41l6d2ANCgDshmwOFZZrCLy+2MRfkxR+E8DdFxMUoeJWfpiYMuhZVEcqMMWKfclkZylKZ3GhepvV2HgTRXTaSaN75kugnW+z+bA9R5cjOql3vpQWB1SdSDkfWjrXVG2P/EzqIHKW3ljBGANtMAb8A7cBjztz4Ng/s1D384cY0bAlzfPBl5I2s5DP+8a4OoHDWDmo/IKXAbw/NND3+k10V1YcJ+l1YRbRJmyYtQTEnbmuvK/l/56wg2iV06TZTqs0wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/class_icon1.png
// module id = YAH+
// module chunks = 1